// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"archway-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H12H21V6H17.9492H12H6H3V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 6V11M12 6H3V3H21V6H12ZM12 11H3M12 11H21M4 22L5.9375 6.5M20 22L18.0132 6.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Archway1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'archway-1',
    ref,
    icon: element,
  },
));

Archway1Icon.displayName = 'Archway1Icon';

export default Archway1Icon;
